import { Pipe, PipeTransform } from '@angular/core';

/**
 * Wraps time unit letters (d, h, m) in a span with fw-normal so only those
 * letters are not bold in values like "7h 7m" or "7d 3h 10m".
 */
@Pipe({ name: 'formatTimeUnits' })
export class FormatTimeUnitsPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value == null) return '';
    const s = typeof value === 'number' ? String(value) : value;
    return s.replace(/(\d+)([dhm])/g, '$1<span class="fw-normal encounter-time-unit">$2</span>');
  }
}
